import { Platform } from "react-native";

export const getPlatform = (): "android" | "ios" | "web" => {
  if (Platform.OS === "android" || Platform.OS === "ios") {
    return Platform.OS;
  }
  return "web";
};

export const isWeb = getPlatform() === "web";
export const isAndroid = getPlatform() === "android";
export const isIos = getPlatform() === "ios";
